import React from 'react'
import { SvgProps } from 'src/shared/types/svg-props-type'

export const ToggleSidebarIcon = (props?: SvgProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="56"
      viewBox="0 0 18 56"
      fill="currentColor"
      {...props}
    >
      <title>{props?.title}</title>
      <path
        d="M18 36.4873C18 39.3564 16.695 42.0871 14.4172 43.9854L0 56L0 0L14.4172 12.0146C16.695 13.9129 18 16.6436 18 19.5127L18 36.4873Z"
        fill="%23E4E5E7"
      />
    </svg>
  )
}
